import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ServiceCardData = {
  icon?: LucideIconName
  header: string
  html: string
  ctaText?: string
  ctaLink?: string
  marginBottom: string
  marginTop: string
}

export const serviceCard: DynamicContentType<ServiceCardData> = {
  name: 'serviceCard',
  viewName: 'Erbjudande',
  featureKey: 'serviceCard',
  icon: LucideIconName.Grid2X2Check,
  default: false,
  uuid: '',
  data: {
    header: 'Mitt erbjudande',
    html: '<p>Beskrivning av erbjudandet</p>',
    marginBottom: '1rem',
    marginTop: '1rem',
  },
}
